import { APP_DTL_BILL_INFO } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_BILL_INFO";
import { CommonCodeMList } from "@/tz/go/egaz/osci/lpco/comn/ComnCdMLst";
import { OrgDeptMList } from "@/tz/go/egaz/osci/lpco/comn/OrgDeptMLst";
import { UsrList } from "@/tz/go/egaz/osci/lpco/comn/UsrLst";
import { Routes, Route } from "react-router-dom";
import { APP_STAT_PPUP } from "../comn/APP_STAT_PPUP";
import { APP_SPFC_CD_PPUP } from "../comn/APP_SPFC_CD_PPUP";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 */
export const OsciLpcoComnRouter = () => {
    return (
        <Routes>
            {/* Postal Code Popup !== 우편 코드 팝업 ==! */}
            <Route path="/esweBllInfoPpup" element={<APP_DTL_BILL_INFO />} />
            <Route path="/appStatPpup" element={<APP_STAT_PPUP />} />

            <Route path="/comn-cd-m" element={<CommonCodeMList />} />
            <Route path="/org-dept" element={<OrgDeptMList />} />
            <Route path="/usr" element={<UsrList />} />
            <Route path="/spfc-cd" element={<APP_SPFC_CD_PPUP />} />
        </Routes>
    );
};
